export const api = {
  host: 'https://frelish.api.flowsmart.ai'
};
